module.exports = __webpack_public_path__ + "img/cloth_g1_pants_07.4b00767e.svg";